app
    .controller('prViewCtrl', function ($rootScope, $scope, $q, _API_URL, $state, $window, shareData,modalFactory,modalService, $filter, urlServices, _VAR_GLOBAL,toaster,$location) {
        $scope.filter = '';
        $scope.dataList = {
            totalItems: 0,
            summary:{},
            data: []
        };
        $scope.paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };
        $scope.currentStatusFilter = null;
        $scope.perTglP = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.edit=function(dt){
            console.log(dt);
            return window.location=_API_URL+'pr-entry?isedit=true&prno='+ dt.NoBukti;

        };
        $scope.refreshData=function(){
            return $scope.viewData(1);
        };
        $scope.hapus=function(dt){
            console.log(dt);
            $scope.NoBukti=dt.NoBukti;
            modalService.showModal({}, {
                closeButtonText: 'No',
                actionButtonText: 'Yes',
                headerText: 'Hapus PR',
                bodyText: 'Anda yakin ingin menghapus PR ' + dt.NoBukti + ' ?'
            })
            .then(function (result) {
                if (result) {
                    urlServices.hapusData('api/purchase-requisition?prno='+ $scope.NoBukti,{}, function (g, s) {
                        if (g) {
                            if (g && g.err && g.err instanceof Array) {
                                console.log('error');
                                $scope.errorMessage = g.err;
                                var elP = '';
                                for (var key in $scope.errorMessage) {
                                    elP +=  $scope.errorMessage[key].msg;
                                }
                                console.log(elP)
                                toaster.pop('error', 'error data', elP);


                            } else {
                                toaster.pop('error', 'error data', g.err);


                            }
                        } else {

                            toaster.pop('success', 'Success', 'Data dihapus');
                            $scope.refreshData();



                        }
                    })

                }
            })

        };
        $scope.buatPo=function(dt){
            console.log(dt)
            return window.location=_API_URL+'potransaksi?pr=true&prno='+ dt.NoBukti;
        };
        $scope.approve=function(dt){
            shareData.setDataDetails(dt);


            modalService.showModal({}, {
                closeButtonText: 'No',
                actionButtonText: 'Yes',
                headerText: 'Approve PR ',
                bodyText: 'Approve PR : ' +  dt.NoBukti
            })
            .then(function (result) {
                var dtS=shareData.getDataDetails();
                if (result) {

                    urlServices.approvePr(dtS.NoBukti,function(g,s){
                        if(g){
                            console.log('error');
                            toaster.pop('error','Error',g);
                        }else{
                            toaster.pop('success','sucess',s);
                        }
                    })
                }
            });


        };
        $scope.reject=function(dt){
            var reason = prompt('Masukkan alasan reject PR ' + dt.NoBukti + ':');
            if (!reason || !reason.trim()) {
                toaster.pop('warning', 'Peringatan', 'Alasan reject wajib diisi');
                return;
            }
            shareData.setDataDetails(dt);

            modalService.showModal({}, {
                closeButtonText: 'Batal',
                actionButtonText: 'Ya, Reject',
                headerText: 'Reject PR',
                bodyText: 'Reject PR: ' + dt.NoBukti + '\nAlasan: ' + reason
            })
            .then(function (result) {
                var dtS=shareData.getDataDetails();
                if (result) {
                    urlServices.rejectPr(dtS.NoBukti, reason, function(g,s){
                        if(g){
                            toaster.pop('error','Error',g);
                        }else{
                            toaster.pop('success','Berhasil','PR berhasil direject');
                            $scope.refreshData();
                        }
                    });
                }
            });
        };
        $scope.viewData = function (pg,qry) {
            if (typeof qry !== 'undefined') {
                $scope.currentStatusFilter = qry;
            }
            $scope.paginationOptions.pageNumber = pg;
            $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter,$scope.currentStatusFilter);
        };
        $scope.detail=function(n){
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'prViewList',
                params: {
                    no:n.NoBukti
                }
            });
        };
        $scope.getData = function (pageSize, page, searchText, qry) {
            var qry = qry||null;
            var data;
            if (searchText) {
                var ft = searchText.toLowerCase();
                data = 'term=' + ft + '&limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry){
                    data +='&status='+qry;
                }
            } else {
                data = 'limit=' + pageSize + '&pg=' + page +   '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry){
                    data +='&status='+qry;
                }
            }

            if (page === 1) {
                $q.all({
                    summary: urlServices.ambilDataPromise(
                        'api/purchase-requisition/summary?start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd"),
                        {}
                    ),
                    list: urlServices.ambilDataPromise('api/purchase-requisition/filter?' + data, {})
                }).then(function (results) {
                    $scope.dataList.summary = results.summary[0] || {};
                    $scope.dataList.totalItems = results.list.records || 0;
                    $scope.dataList.data = results.list.data || [];
                }, function (err) {
                    toaster.pop('error', 'Error', err);
                    $scope.dataList.totalItems = 0;
                    $scope.dataList.data = [];
                });
            } else {
                urlServices.ambilData('api/purchase-requisition/filter?' + data, {}, function (err, result) {
                    if (err || (result && result.err)) {
                        toaster.pop('error', 'Error', err || (result && result.err));
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = [];
                        return;
                    }
                    $scope.dataList.totalItems = result.records || 0;
                    $scope.dataList.data = result.data || [];
                });
            }
        };
        $scope.$watch('perTglP', function (newDate) {
            //console.log('New date set: ', newDate);
            $scope.viewData(1);

        }, false);
        $scope.viewData(1);
    })
